import { helpers } from 'app-webtech-core';
import { toggleFullscreen } from 'app-modules/player/actions';
import { BACK } from './types';

const remoteControllerBackButtonAction = helpers.actions.actionCreator(BACK);

export const remoteControllerBackButtonThunkAction = () => async (dispatch) => {
  await dispatch(remoteControllerBackButtonAction());
  await dispatch(toggleFullscreen());
};
